import React from "react";
import FadeInWhenVisible from "@/components/animations/FadeInWhenVisible";
import Banner from "./banner/";
import SectionCompanyVip from "./section/sectionCompanyVip";
import SectionJobCategories from "./section/sectionJobByMajor";
import SectionJobCareer from "./section/sectionJobCareer";
import SectionJobLocal from "./section/sectionLocal";
import SectionJobNew from "@/pages/home/section/sectionJobNew/JobList";
import {IndustrialSectionIndex} from "@/pages/home/section/IndustrialSection/IndustrialSectionIndex";

const Home = () => {
    return (
        <div className="min-h-screen">
            <div className="relative overflow-hidden">
                <Banner/>
                {/* <SearchBar /> */}
            </div>
            <div className="bg-gray-100">
                <div className="container mx-auto lg:px-0 md:px-10">
                    {/* <div className="space-y-4"> */}
                    <FadeInWhenVisible>
                        <SectionJobNew/>
                    </FadeInWhenVisible>
                    <FadeInWhenVisible>
                        <SectionCompanyVip/>
                    </FadeInWhenVisible>
                    <FadeInWhenVisible>
                        <SectionJobCategories/>
                    </FadeInWhenVisible>
                    {/*<FadeInWhenVisible>*/}
                    {/*  <SectionJobCareer />*/}
                    {/*</FadeInWhenVisible>*/}
                    <FadeInWhenVisible>
                        <IndustrialSectionIndex/>
                    </FadeInWhenVisible>
                    {/* </div> */}
                </div>
            </div>
        </div>
    );
};

export default Home;
